import { SubscriptionData } from '@interfaces/auth'
import { Tables } from '../../../functions/api/types/db'
import api from '../api'

const getSummary = () => {
  return api.get('/api/billing/summary')
}

type Price = Tables<'prices'>

// Simple debounce implementation (stores in client-side memory)
let billingTimeout: NodeJS.Timeout | null = null

const getBilling: () => Promise<{ data: { subscription: SubscriptionData } }> = () => {
  return new Promise((resolve, reject) => {
    if (billingTimeout) clearTimeout(billingTimeout)

    billingTimeout = setTimeout(() => {
      api.get('/api/billing/verify').then(resolve).catch(reject)
    }, 500)
  })
}

const getProducts = () => {
  return api.get('/api/billing/products')
}

const getActiveProductMetadata = () => {
  return api.get('/api/billing/active-product')
}

const updateActiveProductMetadata = (metadata: any) => {
  return api.patch('/api/billing/active-product', { metadata })
}

const createSubscription = (priceId: string) => {
  return api.get(`/api/billing/subscribe/${priceId}`)
}

const checkoutWithStripeSubscription = async (price: Price) => {
  return api.post('/api/billing/checkout-with-stripe-subscription', {
    ...price,
  })
}

const checkoutWithStripeOneTime = async (documentId: string) => {
  return api.post(`/api/billing/checkout-with-stripe-one-time/${documentId}`)
}

const createStripePortal = async (currentPath: string = '') => {
  return api.post('/api/billing/create-stripe-portal', { currentPath })
}

const checkoutCallback = async (paymentIntent: string = '') => {
  if (!paymentIntent) return api.get('/api/billing/checkout/callback')
  return api.get(`/api/billing/checkout/callback/${paymentIntent}`)
}

const openStripePortal = async () => {
  const stripePortalResponse = await createStripePortal()
  const { url } = stripePortalResponse.data
  window.location.href = url
}

export const billing = {
  getBilling,
  getProducts,
  getActiveProductMetadata,
  updateActiveProductMetadata,
  getSummary,
  checkoutWithStripeSubscription,
  checkoutWithStripeOneTime,
  createStripePortal,
  createSubscription,
  checkoutCallback,
  openStripePortal,
}
